module.exports = __webpack_public_path__ + "f24a778a2751e585d30fca7004a1c80e.png";